import { HookOutOfContextError } from "@jugl-web/utils";
import { useContext } from "react";
import { OnboardingContext } from "./OnboardingContext";

export const useOnboarding = () => {
  const context = useContext(OnboardingContext);

  if (!context) {
    throw new HookOutOfContextError("useOnboarding", "OnboardingContext");
  }

  return context;
};
